import type { FC } from 'react';

import { ActivityResourceIdentity } from '@/shared/components/activity/ResourceActivityIdentity';
import EnrichedPill from '@/shared/components/enriched-pills/EnrichedPill';
import WorkspaceResourceAvatar from '@/shared/components/workspace-resources/WorkspaceResourceAvatar';
import type { AuditLog } from '@/types';

import { normalizeAuditResource } from '../auditLogFilters';
import {
    getAuditDetails,
    getAuditResourceHref,
    getAuditResourceTitle,
    getAuditResourceType,
} from '../auditLogPresentation';

const stringValue = (value: unknown) => (typeof value === 'string' && value.trim() ? value.trim() : undefined);

const AuditLogResourceIdentity: FC<{ log: AuditLog }> = ({ log }) => {
    const details = getAuditDetails(log);
    const resourceLabel = normalizeAuditResource(log.entityType);
    const resourceType = getAuditResourceType(log);
    const label = getAuditResourceTitle(log);
    const href = getAuditResourceHref(log, resourceType);
    const listType = stringValue(details.listType) ?? stringValue(details.type);
    const website = stringValue(details.website) ?? stringValue(details.companyWebsite);

    if (resourceType && log.entityId) {
        return (
            <ActivityResourceIdentity
                href={href}
                id={log.entityId}
                label={label}
                listType={listType}
                resourceType={resourceType}
                updatedAt={new Date(log.updatedAt ?? log.createdAt).toISOString()}
                website={website}
            />
        );
    }

    return (
        <EnrichedPill interactive={false}>
            <WorkspaceResourceAvatar resource={resourceType ?? resourceLabel} size={16} />
            <span>{label}</span>
        </EnrichedPill>
    );
};

export default AuditLogResourceIdentity;
